export default "__VITE_ASSET__DyRHjVZM__"